import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactIntersectionObserver from '../react-intersection-observer/ReactIntersectionObserver';
import {pushEdapEvent} from '../../../utils/edap';

/**
 * Triggers an EDAP page.module.view event by default when its child becomes visible on the
 * client viewport.
 *
 * If no child is passed, an invisible element is used instead.
 */
export default class EdapViewTracker extends Component {
    static propTypes = {
        eventData: PropTypes.shape({
            actionlocation: PropTypes.string,
            eventlbsuuid: PropTypes.string,
            eventrefinements: PropTypes.string,
        }).isRequired,
        children: ReactIntersectionObserver.propTypes.children,
        edapEvent: PropTypes.string,
        threshold: PropTypes.number,
    };

    static defaultProps = {
        children: null,
        edapEvent: 'page.module.view',
    };

    constructor(props) {
        super(props);
        this.state = {hasBeenSeen: false};
    }

    onIntersection = ({isIntersecting}) => {
        const {eventData, edapEvent} = this.props;

        this.setState((state) => {
            if (isIntersecting && !state.hasBeenSeen) {
                pushEdapEvent(edapEvent, eventData);
                return {hasBeenSeen: true};
            }
            return null;
        });
    };

    render() {
        const {children, threshold} = this.props;

        return this.state.hasBeenSeen ? (
            children
        ) : (
            <ReactIntersectionObserver
                onIntersection={this.onIntersection}
                threshold={threshold}
            >
                {children}
            </ReactIntersectionObserver>
        );
    }
}
